import { api } from './api'

// ========================================
// TYPES
// ========================================

export interface CampaignStats {
  total: number
  sent: number
  failed: number
}

export interface EmailCampaign {
  _id: string
  name: string
  template_id: string
  template_slug: string
  template_subject: string
  user_ids: string[]
  status: 'processing' | 'completed' | 'failed'
  stats: CampaignStats
  created_by: string
  created_at: string
  completed_at?: string
}

export interface CreateCampaignRequest {
  name: string
  template_id: string
  user_ids: string[]
}

export interface CampaignsListResponse {
  campaigns: EmailCampaign[]
  total: number
  page: number
  page_size: number
  total_pages: number
}

// ========================================
// API SERVICE
// ========================================

export const emailCampaignsService = {
  /**
   * Crear y enviar una nueva campaña de emails
   */
  async createCampaign(request: CreateCampaignRequest): Promise<EmailCampaign> {
    const { data } = await api.post<EmailCampaign>('/email-campaigns', request)
    return data
  },

  /**
   * Listar campañas existentes con paginación
   */
  async listCampaigns(page = 1, pageSize = 20): Promise<CampaignsListResponse> {
    const { data } = await api.get<CampaignsListResponse>('/email-campaigns', {
      params: { page, page_size: pageSize },
    })
    return data
  },

  /**
   * Obtener detalle de una campaña específica
   */
  async getCampaign(campaignId: string): Promise<EmailCampaign> {
    const { data } = await api.get<EmailCampaign>(`/email-campaigns/${campaignId}`)
    return data
  },
}
